<template>
  <base-dialog :showDialog="showDialog">
    <template v-slot:body>
    <div v-show="!isGuest">
      <v-card dark>
        <v-card-title>
          <div>
            <span class="text-h6">Carregar Orçamento</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-if="$vuetify.breakpoint.mobile">
            <v-row dense>
              <v-col cols="4" md="12">
                <v-autocomplete
                  v-model="formSearch.type"
                  :items="typeList"
                  outlined
                  dense
                  label="Parametro"
                  dark
                />
              </v-col>
              <v-col cols="4" md="7">
                <v-text-field
                  v-model="formSearch.value"
                  :label="`Informe o ${formSearch.type}`"
                  type="number"
                  dense
                  dark
                />
              </v-col>
              <v-col cols="4" md="5" v-show="formSearch.type === 'numero'">
                <v-text-field
                  dark
                  dense
                  v-model="formSearch.serie"
                  type="number"
                  :label="`Informe a série`"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  v-model="formSearch.type"
                  :items="typeList"
                  outlined
                  dense
                  label="Parametro"
                  dark
                />
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="formSearch.value"
                  :label="`Informe o ${formSearch.type}`"
                  type="number"
                  dense
                  dark
                />
              </v-col>
            </v-row>
            <v-row v-show="formSearch.type === 'numero'">
              <v-spacer></v-spacer>
              <v-col cols="8">
                <v-text-field
                  v-model="formSearch.serie"
                  :label="`Informe a série`"
                  type="number"
                  dense
                  dark
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
      <v-card dark class="mt-1">
        <v-card-actions>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="red"
                dense
                @click="$emit('close')"
                @shortkey="$emit('close')"
                v-shortkey.once="['esc']"   
                small
                v-on="on"
                v-bind="attrs"
              >
                <v-icon small>mdi-close</v-icon>
                <span class="text-overline px-1">Fechar</span>
              </v-btn>
            </template>
            <span>Fechar Tela</span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="blue"
                dense
                @click="loadOrder()"
                small
                v-on="on"
                v-bind="attrs"
              >
                <v-icon small>mdi-download</v-icon>
                <span class="text-overline px-1">Carregar Orçamento</span>
              </v-btn>
            </template>
            <span>Carregar um orçamento por número ou sequencial</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BaseDialog from "@/components/shared/base-dialog/BaseDialog"
export default {
  components:{BaseDialog},
  data: () => {
    return {
      formSearch: {
        type: 'numero',
        value: '',
        serie: '1',
      },
      typeList: ['numero', 'sequencial'],
    }
  },
  computed: {
    // Company Module
    ...mapState('companyModule', ['companyList']),
    // Departament Module
    ...mapState('departamentModule', ['departamentList']),
    // PDV Balcao Module
    ...mapState('pdvBalcaoModule/orderModule', ['order']),
    // System Module
    ...mapGetters('systemModule', ['getCurrentSystem']),
  },
  methods: {
    async loadOrder() {
      try {
        let loadObject = {}
        loadObject[`${this.formSearch.type}`] = this.formSearch.value || 0
        loadObject['serie'] = this.formSearch.serie
        if (loadObject[`${this.formSearch.type}`] > 0)
          this.$emit('loadOrder', loadObject)
        // deixar para que o index pdv balcao faça esse carregamento
        else throw `O ${this.formSearch.type} de Orçamento informado é inválido`
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  props: {
    isGuest: {
      type: Boolean,
      default: false,
    },
    showDialog:{
      type:Boolean,
      default:false,
      required:true
    }
  },
  mounted() {
    this.formSearch.serie = this.getCurrentSystem
      ? this.getCurrentSystem.SERIEORCAMENTO
      : 0
  },
}
</script>

<style></style>
